import Fetch from 'utils/fetch';

export const postAcceptOrders = (idUsuario, model) => Fetch.post(`/timeline/aceiteemmassa/fornecedor/${idUsuario}`, model).then(({ data }) => data);

export const getOrderDownloadFile = () => Fetch.get(`orders:export-order-negotiation`).then(({ data }) => data);

export const getRevisionDownloadFile = () => Fetch.get(`orders:export-order-review`).then(({ data }) => data)

export const getVolumeOrdersFeatureFlag = () =>
  Fetch.get(`volume-orders:feature-flag`).then(({ data }) => data);

export const aceiteAtualizado = (dto) => Fetch.post(`/volume-orders/${dto.volumeOrder.Id}:accept-partial`, dto).then(({ data }) => data);

export const postCreateDeltaOrder = (dto) =>
  Fetch.post("/volume-orders:accept-delta", dto).then(({ data }) => data);

export const downloadPedidoVolumesEmNegociacao = (idsPedidoVolume) => Fetch.put('pedidoVolume/export/pedidoVolumeEmNegociacao', { Ids: idsPedidoVolume })
  .then(({ data }) => data)
